<template>
  <info-header-card :header="header" :rows="rows">
  </info-header-card>
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import moment from "moment";

export default {
  name: 'ResultManagerCard',
  components: {
    InfoHeaderCard
  },
  props: {
    analyte_result: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    header () {
      return `${this.analyte_result && this.analyte_result.sample ? this.analyte_result.sample.pid : 'TBD'}`
    },
    rows () {
      return [
        {
          label: "Analyte",
          value: this.analyte_result && this.analyte_result.analyte && this.analyte_result.analyte.name
        },
        {
          label: "Result",
          value: this.analyte_result && this.analyte_result.formatted_result
        },
        {
          label: "Raw Result",
          value: this.analyte_result && this.analyte_result.raw_result
        },
        {
          label: "Created On",
          value: this.analyte_result && moment(this.analyte_result.created_at).format("YYYY-MM-DD")
        }
      ]
    }
  }
}
</script>
